import styled from 'styled-components';

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const SectionCheckbox = styled.input`
  width: 1rem;
  height: 1rem;
  margin: 0;
  cursor: pointer;
  accent-color: ${(p) => p.theme.colors.primary};
`;

export const TitleGroup = styled.h3`
  margin: 0;
`;

export const ItemGroup = styled.div`
  opacity: 0.8;
  margin-left: 1.5rem;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${(p) => p.theme.colors.onSurface};
  border-radius: 0.5rem;
  padding: 0.35rem 0.5rem;

  > input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    color: ${(p) => p.theme.colors.onBackground};
  }
`;

export const EmptyState = styled.p`
  margin: 1rem 0 0;
  opacity: 0.8;
`;
